import styled from 'styled-components';
import { COLORS } from '../../consts/colors';
import { Subtitle1Font, Body2Font } from '../../themes/fonts';

export const TooltipContainer = styled.div`
  display: inline-flex;
  align-items: center;
  cursor: pointer;
`;

export const LearnMoreContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 8px;
  margin: 4px 0;
  padding: 0;
`;

export const LearnMoreText = styled.span`
  font-family: Gilroy, sans-serif;
  font-size: 10px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 1.5px;
  text-align: left;
  text-transform: uppercase;
  color: ${COLORS.DARK_PURPLE};
  opacity: 0.6;
  height: 10px;
`;

export const RectangleIconBg = styled.div`
  width: 48px;
  height: 48px;
  padding: 9px;
  border-radius: 12px;
  background-color: ${COLORS.MID_GREY};
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 4px;
`;

export const InfoTooltipContent = styled.div`
  padding: 24px 16px;
  max-width: 414px;
  min-height: 100px;
  background-color: ${COLORS.WHITE1};
  border-radius: 20px;
  box-shadow: 0 6px 20px 0 rgba(0, 0, 0, 0.15);
  display: flex;
  height: auto;
`;

export const TooltipLeftColumn = styled.div`
  margin-right: 14px;
  align-self: flex-start;
`;

export const TooltipRightColumn = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  padding-bottom: 4px;
`;

export const TooltipTitle = styled.div`
  ${Subtitle1Font};
  font-weight: 700;
  margin-bottom: 12px;
  color: ${COLORS.DARK_BLUE};
`;

export const TooltipTitleIcon = styled.div`
  display: flex;
  align-items: flex-start;
`;

export const TooltipText = styled.div`
  ${Body2Font};
  color: ${COLORS.DARK_BLUE};
  opacity: 0.6;
  text-align: left;
  word-wrap: break-word;
`;
